import React from 'react';
import { useNavigate } from 'react-router-dom';
import DiscoveryTab from '../../components/sales/DiscoveryTab';

const DiscoverPage: React.FC = () => {
  const navigate = useNavigate();

  const handleViewLead = (lead: any) => {
    navigate(`/sales/leads/${lead.id}`);
  };

  return (
    <div style={{ width: '100%' }}>
      <DiscoveryTab onViewLead={handleViewLead} />
    </div>
  );
};

export default DiscoverPage;

